module.exports = __webpack_public_path__ + "img/title.cd8f9b42.jpg";